<header class="">
    <div class="container-fluid">
        <div class="text-kl-white kl-display-1 dis-num txt2">
            <ng-container *ngIf="saleStopDays !== null">
                <ng-container *ngIf="saleStopDays > 1">
                    {{ saleStopDays }}
                </ng-container>
            </ng-container>
        </div>
        <div class="splash"><img src="/assets/images/forside_hero/splash.svg" alt=""></div>
         <div class="txt3">
            <ng-container *ngIf="saleStopDays !== null">
                <ng-container *ngIf="saleStopDays > 1">
                    <img class="kl_dage" src="/assets/images/forside_hero/mobile-dage.svg" alt="">
                </ng-container>
                <ng-container *ngIf="saleStopDays === 1">
                    <!-- I MORGEN KL. 10 -->
                    <img class="kl_imorgen" src="/assets/images/forside_hero/mobile-imorgen.svg" alt="">
                </ng-container>
                <ng-container *ngIf="saleStopDays === 0">
                   <!-- <div class="text-kl-white kl-display-1"> 
                    I DAG <br> KL. 10</div> -->
                    <img class="kl_idag" src="/assets/images/forside_hero/mobile-idag.svg" alt="">
                </ng-container>
            </ng-container>
        </div>
        <div class="cta mx-auto text-center">
            <a (click)="redirectShop()" class="btn btn-kl-blue btn-lg pulse">SPIL MED</a>
        </div>  
        <div class="row "> 
            <div class="text-kl-white text-center mx-auto mt-3">
                <div class="kl-display-0 mt-3 txt1">
                    Salget til denne måneds <br>trækning
                    <ng-container *ngIf="saleStopDays !== null"> lukker</ng-container> 
                    <ng-container *ngIf="saleStopDays === null"> er lukket. <br> Spil med igen i {{ nextDrawDate | date : "MMMM" }}!</ng-container> 
                    <ng-container *ngIf="saleStopDays > 1"> om</ng-container>
                </div>          
            </div>
        </div> <!--row-->
    </div>
    <div class="win-fee">
        <p class="win-fee-note">Hver gevinst over 200 kr. fratrækkes gevinstafgift på 15 % inden udbetaling.</p>   
    </div>
</header>
